import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./purchase.css";
import swal from "sweetalert";
import Table from "react-bootstrap/Table";
import logUserActivity from "../utils/logUserActivity"; 


function Purchase() {
  const [Porder, setPorder] = useState([]);
  const [distDetails, setDistDetails] = useState([]);
  const [CPO, setCPO] = useState([]);
  const [distributorName, setDistributorName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [Shelf, setShelf] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);


  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`)
      .then((response) => {
        const allData = response.data;
        const activeData = allData.filter(
          (form) => form.AuthStatus === "active"
        );
        setPorder(activeData);
      })
      .catch((error) => {
        console.error("Error fetching data:", error); 
      });
  }, []);

  useEffect(() => {
    Axios.get(
      `${INVENTORY_API_BASE_URL}/getCreatesuperdistributor`
    ).then((respo) => {
      setDistDetails(respo.data);
    });
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreateshelf`)
      .then((respon) => {
        const shelfData = respon.data.reduce((acc, item) => {
          const existingItem = acc.find((x) => x.sku === item.sku);
          if (existingItem) {
            existingItem.presentquantity += item.presentquantity;
            existingItem.shelfData.push({
              shelfno: item.shelfno,
              presentquantity: item.presentquantity,
            });
          } else {
            acc.push({
              sku: item.sku,
              presentquantity: item.presentquantity,
              shelfData: [
                {
                  shelfno: item.shelfno,
                  presentquantity: item.presentquantity,
                },
              ],
            });
          }
          return acc;
        }, []);
        setShelf(shelfData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleInputChange = (sku, column, value, row) => {
    const index = Porder.findIndex((row) => row.sku === sku);
    const newTableData = [...Porder];
    newTableData[index][column] = value;

    if (column === "quantity1" || column === "currentstocks") {
      if (!CPO.some((selectedlist) => selectedlist.sku === row.sku)) {
        swal({
          title: "Please select the checkbox first",
          text: "",
          icon: "error",
        });
        return;
      }

      if (!distributorName) {
        swal({
          title: "Please select a distributor",
          text: "",
          icon: "error",
        });
        return;
      }

      const discountPercentage = getSelectedDistributorDiscount(
        row.distributorName
      );
      const mrp = newTableData[index].mrp;

      newTableData[index].discountValue = (
        (discountPercentage / 100) *
        mrp
      ).toFixed(2);
      newTableData[index].PurchaseValue = (
        mrp - newTableData[index].discountValue
      ).toFixed(2);
      newTableData[index].OrderValue = (
        newTableData[index].quantity1 * newTableData[index].PurchaseValue
      ).toFixed(2);
    }

    newTableData[index].distributorName = distributorName;

    const newTableDataArray = Object.values(newTableData);
    setPorder(newTableDataArray);
  };

  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    const selectedlist = Porder.find((listdata) => listdata.sku === value);

    if (!distributorName) {
      swal({
        title: "Please select a distributor",
        text: "",
        icon: "warning",
      });
      return;
    }

    if (event.target.checked) {
      setCPO([...CPO, selectedlist]);
    } else {
      setCPO(CPO.filter((listdata) => listdata.sku !== selectedlist.sku));
    }
  };

  function handleSubmit() {
    if (isSubmitting) return;
    setIsSubmitting(true);
  
    const postData = {
      distributorName: distributorName,
      CPO: CPO,
    };
  
    Axios.post(`${INVENTORY_API_BASE_URL}/postPurchase`, postData)
      .then(async (result) => {
        swal({
          title: "Order Created",
          text: "",
          icon: "success",
        });
  
       
        await logUserActivity("CREATE_PURCHASE_ORDER", {
          distributorName,
          totalItems: CPO.length,
          fullSubmittedData: CPO, 
        });
  
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error submitting purchase order:", error);
        swal({
          title: "Order Creation Failed",
          text: "",
          icon: "error",
        });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }
  
  

  const getSelectedDistributorDiscount = (selectedDistributorName) => {
    const selectedDistributor = distDetails.find(
      (dist) => dist.dname === selectedDistributorName
    );
    return selectedDistributor ? selectedDistributor.discount : "";
  };

  const filteredPorder = Porder.filter((row) =>
    row.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    row.sku.toLowerCase().includes(searchTerm.toLowerCase())
  );
  

  const getPresentQuantityForSKU = (sku) => {
    const shelfItem = Shelf.find((item) => item.sku === sku);
    if (!shelfItem) {
      return { quantity: "N.F", tooltip: "No data found" };
    }

    const totalQuantity = shelfItem.presentquantity;
    const tooltip = shelfItem.shelfData
      .map((item) => `${item.shelfno} --> ${item.presentquantity}`)
      .join("\n");

    return { quantity: totalQuantity, tooltip };
  };

  const totalStock = Shelf.reduce(
    (total, item) => total + item.presentquantity,
    0
  );

  const isFormValid = () => {
    if (CPO.length === 0) return false;

    return CPO.every((item) => {
      const quantity = Number(item.quantity1);
      const stock = Number(item.currentstocks);
      return quantity > 0 && stock >= 0;
    });
  };

  return (
    <div className="cpo purchase-page">
      <header className="purchase-page__header">
        <div>
          <p className="purchase-page__eyebrow">PURCHASING WORKSPACE</p>
          <h1>Create purchase order</h1>
          <p className="purchase-page__description">
            Select a distributor, choose active books, and enter order quantities.
          </p>
        </div>
        <div className="purchase-page__header-note">
          <span className="purchase-page__header-mark" aria-hidden="true">PO</span>
          <div>
            <span>Order planning</span>
            <strong>Distributor purchase</strong>
          </div>
        </div>
      </header>

      <section className="filter-container purchase-toolbar" aria-label="Purchase order controls">
        <label className="purchase-control" htmlFor="purchase-distributor">
          <span>Distributor</span>
          <select
            id="purchase-distributor"
            className="distributor-select"
            value={distributorName}
            onChange={(e) => setDistributorName(e.target.value)}
          >
            <option value="">Select Distributor</option>
            {distDetails.map((item) => (
              <option key={item.id} value={item.dname}>
                {item.dname}
              </option>
            ))}
          </select>
        </label>

        <label className="purchase-control purchase-control--search" htmlFor="purchase-search">
          <span>Search catalog</span>
          <input
            id="purchase-search"
            className="search-input"
            type="text"
            placeholder="Search by SKU or book title"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </label>

        <button
          type="submit"
          className="cpob1"
          onClick={handleSubmit}
          disabled={isSubmitting || !isFormValid()}
        >
          <span aria-hidden="true">＋</span>
          {isSubmitting ? "Submitting..." : "Create Purchase Order"}
        </button>
      </section>

      <section className="purchase-summary" aria-label="Purchase order summary">
        <article className="purchase-summary-card purchase-summary-card--stock">
          <span className="purchase-summary-card__icon" aria-hidden="true">STK</span>
          <div>
            <span>Available warehouse stock</span>
            <strong>{totalStock.toLocaleString()}</strong>
            <small>Units across all shelves</small>
          </div>
        </article>

        <article className="purchase-summary-card purchase-summary-card--selection" aria-live="polite">
          <div className="purchase-summary-card__heading">
            <div>
              <span>ORDER SELECTION</span>
              <strong>{CPO.length.toLocaleString()} {CPO.length === 1 ? "book" : "books"}</strong>
            </div>
            <span className="purchase-summary-card__status">
              {CPO.length > 0 ? "Ready to review" : "Select books to begin"}
            </span>
          </div>
          {CPO.length > 0 ? (
            <div className="purchase-selected-list">
              {CPO.map((item) => (
                <span className="purchase-selected-item" key={item.sku}>
                  <strong>{item.sku}</strong>
                  <span>Qty {item.quantity1 || 0}</span>
                </span>
              ))}
            </div>
          ) : (
            <p className="purchase-summary-card__hint">
              Choose a distributor, then select books from the catalog below.
            </p>
          )}
        </article>
      </section>

      <div className="purchasecontainer" role="region" aria-labelledby="purchase-catalog-title">
        <div className="purchase-section-heading">
          <div>
            <p className="purchase-section-heading__eyebrow">ACTIVE CATALOG</p>
            <h2 id="purchase-catalog-title">Available books</h2>
            <p>Select the books to include and enter their quantities.</p>
          </div>
          <span className="purchase-result-count">
            {filteredPorder.length.toLocaleString()} {filteredPorder.length === 1 ? "book" : "books"}
          </span>
        </div>
        <div className="purchasecontent">
          <Table className="createtablecpo" aria-label="Active books for purchase">

            <thead>
              <tr>
                <th scope="col">Select</th>
                <th scope="col" id="pr-sku">SKU</th>
                <th scope="col">Cover</th>
                <th scope="col">Warehouse stock</th>
                <th scope="col">Distributor stock</th>
                <th scope="col">Order quantity</th>
                <th scope="col">Book title</th>
                <th scope="col">Medium</th>
                <th scope="col">Publication date</th>
                <th scope="col">Edition</th>
                <th scope="col">MRP</th>
                <th scope="col">Discount</th>
                <th scope="col">Purchase price</th>
                <th scope="col">Order value</th>
              </tr>
            </thead>

            <tbody>
              {filteredPorder.length === 0 ? (
                <tr>
                  <td className="purchase-empty-cell" colSpan={14}>
                    <strong>No books found</strong>
                    <span>Try another SKU or title search.</span>
                  </td>
                </tr>
              ) : filteredPorder.map((row) => {
                const { quantity, tooltip } = getPresentQuantityForSKU(row.sku);
                return (
                  <tr
                    key={row.sku}
                    className={CPO.some((selectedlist) => selectedlist.sku === row.sku) ? "purchase-row--selected" : ""}
                  >
                    <td>
                      <input
                        className="purchase-row-checkbox"
                        type="checkbox"
                        aria-label={"Select " + row.title}
                        name="listdata"
                        value={row.sku}
                        onChange={handleCheckboxChange}
                        checked={CPO.some(
                          (selectedlist) => selectedlist.sku === row.sku
                        )}
                      />
                    </td>
                    <td><span className="purchase-sku">{row.sku}</span></td>
                    <td>
                      <img
                        className="purchase-book-image"
                        src={`https://d10idqgatxnd06.cloudfront.net/${row.img}`}
                        width="70"
                        height="70"
                        alt={row.title ? row.title + " cover" : "Book cover"}
                      />
                    </td>
                    <td className="purchase-stock-cell">
                      <i className="fa fa-eye" title={tooltip} aria-hidden="true"></i>{" "}
                      {quantity}
                    </td>
                    <td>
                      <input
                        className="input-without-spinner purchase-number-input"
                        type="number"
                        aria-label={"Current stock for " + row.sku}
                        value={row.currentstocks}
                        onChange={(e) =>
                          handleInputChange(
                            row.sku,
                            "currentstocks",
                            e.target.value,
                            row
                          )
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td>
                      <input
                        className="input-without-spinner purchase-number-input"
                        type="number"
                        aria-label={"Order quantity for " + row.sku}
                        value={row.quantity1}
                        onChange={(e) =>
                          handleInputChange(
                            row.sku,
                            "quantity1",
                            e.target.value,
                            row
                          )
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                    </td>
                    <td className="purchase-title-cell"><span title={row.title}>{row.title}</span></td>
                    <td>{row.Medium}</td>
                    <td>{row.date}</td>
                    <td>{row.edition}</td>
                    <td>{row.mrp}</td>
                    <td>
                      {getSelectedDistributorDiscount(row.distributorName)}
                    </td>
                    <td>{row.PurchaseValue}</td>
                    <td>{row.OrderValue}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
      </div>

    </div>
  );
}

export default Purchase;
